// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSection-module--wrapper--S+BuF";
export var infoWrapper = "HeroSection-module--infoWrapper--6EsKN";
export var title = "HeroSection-module--title--tyi6H";
export var address = "HeroSection-module--address--yalTK";
export var avatarWrapper = "HeroSection-module--avatarWrapper--RiXAE";
export var bgBlock = "HeroSection-module--bgBlock--2cqNA";
export var mobileBlocks = "HeroSection-module--mobileBlocks--tYiLm";
export var phone = "HeroSection-module--phone--29G-R";
export var calendar = "HeroSection-module--calendar--vorVM";